import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import {
  DialogButtonProps,
  DialogProps,
} from 'shared/components/vxl/Dialog/Dialog';
import theme from 'shared/styles/theme';

const BUTTON_ROW = 1;
const BUTTON_COLUMN = 0;
const MAX_BUTTON_ROW_HEIGHT = 59;

const WebButtonContainer = ({ dialogButtonProps }: DialogProps) => {
  const [buttonLayoutOrientation, setButtonLayoutOrientation] =
    useState(BUTTON_ROW);

  const getLayoutOrientation = () => {
    return buttonLayoutOrientation === BUTTON_ROW
      ? styles.flexDirectionRow
      : styles.flexDirectionColumn;
  };

  const getMarginStart = (index: number) => {
    return dialogButtonProps.length > 1 &&
      buttonLayoutOrientation === BUTTON_ROW &&
      index !== 0
      ? styles.marginStart16
      : styles.marginStart0;
  };

  const getMarginTop = (index: number) => {
    if (
      dialogButtonProps.length > 1 &&
      buttonLayoutOrientation === BUTTON_COLUMN &&
      index !== 0
    ) {
      return styles.marginTop16;
    }
    return styles.marginTop0;
  };

  return (
    <View
      style={[styles.webButtonContainer, getLayoutOrientation()]}
      onLayout={(e) => {
        if (e.nativeEvent.layout.height > MAX_BUTTON_ROW_HEIGHT) {
          setButtonLayoutOrientation(BUTTON_COLUMN);
        }
      }}
    >
      {dialogButtonProps?.map((item: DialogButtonProps, index: number) => {
        return (
          <View
            key={`Button-${item.label}`}
            style={[
              styles.webButton,
              getMarginStart(index),
              getMarginTop(index),
            ]}
          >
            <Button
              type={
                index === dialogButtonProps.length - 1 ? 'PRIMARY' : 'SECONDARY'
              }
              label={item.label}
              testID={item.testID}
              onPress={() => {
                if (item.onClick) {
                  item.onClick();
                }
              }}
            />
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  flexDirectionColumn: {
    flexDirection: 'column',
  },
  flexDirectionRow: {
    flexDirection: 'row',
  },
  marginStart0: {
    marginStart: 0,
  },
  marginStart16: {
    marginStart: theme.spacing.m,
  },
  marginTop0: {
    marginTop: 0,
  },
  marginTop16: {
    marginTop: theme.spacing.m,
  },
  webButton: {
    alignSelf: 'flex-end',
    maxWidth: 368,
  },
  webButtonContainer: {
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    marginTop: theme.spacing.xl,
  },
});

export default WebButtonContainer;
